// extracted by mini-css-extract-plugin
module.exports = {"character":"Character_character__24YT1"};